<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit">
<a id="page03">
<h2 class="titlePageAuthor"><span class="bold">JANET DEAN</span></h2>
<h2 class="titlePageTitle"><em class="italic"><span class="bold">The Substitute Bride</span></em></h2>
<p class="titlePageLogo"><img alt="image" src="Images/logo.jpg"/></p>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// substitutebridethe_tit.vue?4dc11f53